import PropTypes from 'prop-types';

import { TabsWrapper, Tab } from './Tabs.style';

const Tabs = props => {
  const { options, value, onChange } = props;
  const handleTabClick = val => {
    onChange(val);
  };

  return (
    <TabsWrapper>
      {options.map(option => (
        <Tab
          key={option.value}
          onClick={() => {
            handleTabClick(option.value);
          }}
          active={option.value === value}
        >
          {option.name}
        </Tab>
      ))}
    </TabsWrapper>
  );
};

Tabs.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  onChange: PropTypes.func,
};

Tabs.defaultProps = {
  value: '',
  onChange: () => {},
};

export default Tabs;
